<template>
  <div class="card-popup" v-show="!cardLoading">
    <Floating
      :visible.sync="showCard"
      :width="isH5 ? '100%' : '470px'"
      :close-on-click-modal="false"
      v-if="showCard"
      custom-class="card-popup-floating el-floating_d-reset"
      :title="$t('FoodC_recommended_Please_select_dJyk')"
      @close="closeDrawer"
      :appendToBody="false"
    >
      <CardContent @update="getInit" />
      <div class="info-btn">
        <el-button @click="confirmClick" :disabled="isDisabled">{{
          $t('FoodC_demand_Determination_wKQX')
        }}</el-button>
      </div>
    </Floating>
  </div>
</template>

<script>
import stopper from '@/utils/stopper';
import CardContent from './cardContent.vue';
import { Floating } from '@didi/r-fusion-pc';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'CardPopup',
  components: {
    CardContent,
    Floating,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    paymentParams: {
      type: Object,
      default() {
        return {};
      },
    },
    source: {
      type: String,
      default: '', // 组件来源 bill
    },
  },
  data() {
    return {
      showCard: false,
      cardObj: {},
      isDisabled: false,
    };
  },
  computed: {
    ...mapState({
      extraInfoList: ({ pay }) => pay.extraInfoList,
      selectedMent: ({ pay }) => pay.selectedMent,
      selectedCard: ({ pay }) => pay.selectedCard,
      cardLoading: ({ pay }) => pay.cardLoading,
      isH5: ({ common }) => common.isH5,
    }),
  },
  watch: {
    value(val) {
      this.showCard = val;
    },
    selectedMent: {
      handler(val) {
        this.isDisabled = !Object.keys(val)?.length;
      },
      immediate: true,
    },
    showCard(val) {
      if (!val) this.delPayData();
      this.$emit('input', val);
    },
  },
  async mounted() {
    this.getInit();
  },
  methods: {
    ...mapActions('pay', ['getPayInfo', 'delPayData']),
    ...mapMutations('pay', [
      'setSelectedCard',
      'setSelectedMent',
      'setCardLoading',
    ]),
    async getInit() {
      this.setCardLoading(true);
      await this.getPayInfo(this.paymentParams);
      this.setCardLoading(false);
    },
    closeDrawer() {
      this.setSelectedMent(this.selectedCard);
      this.showCard = false;
      this?.closeDrawer2();
      this.closeAfter();
    },
    confirmClick() {
      this.setSelectedCard(this.selectedMent);
      this.showCard = false;
      this?.confirmClick2();
      this.closeAfter();
      // this.$emit('update', this.selectedMent);
    },
    closeAfter() {
      if (this.source === 'bill') {
        stopper.start();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-btn {
  padding: 10px 24px 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  .el-button {
    min-width: 140px;
  }
}
@media screen and (max-width: 768px) {
  .info-btn {
    padding: 20px;
    position: fixed;
    bottom: rem(20);
    width: 100%;
    .el-button {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.card-popup-floating {
  background: #f5f5f7;
}
.card-popup .el-drawer {
  background: #f5f5f7;
}
</style>
